/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_LeaderInputs */

const cs_settings_teams_leader = /** @type {(inputs: Settings_Teams_LeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedoucí`)
};

const en_settings_teams_leader = /** @type {(inputs: Settings_Teams_LeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leader`)
};

/**
* | output |
* | --- |
* | "Leader" |
*
* @param {Settings_Teams_LeaderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_leader = /** @type {((inputs?: Settings_Teams_LeaderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_LeaderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_leader(inputs)
	return cs_settings_teams_leader(inputs)
});